<template>
  <div class="bg-blue-800 h-full w-full">
    <div class="container mx-auto px-4 h-full pt-24 min-h-screen">
      <div class="flex content-center items-center justify-center h-full">
        <div class="w-full lg:w-7/12 px-4">
          <div
            class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-100 border-0"
          >
            <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
              <div class=" mb-3">
                <img class="m-auto" src="@/assets/musicverse-logo.png" style="width: 150px"/>
              </div>
              <h6 class="font-bold text-center mb-8 text-3xl">Sign Up</h6>
              <form-wizard ref="formWizard" shape="tab" @on-complete="onCompleteSave" color="#3498db" title="" subtitle="">
                <tab-content title="Account Details" :before-change="()=>validateStep('step1')">
                  <FormSignupUser ref="step1" @on-validate="mergePartialModels" :isEmailExist="isEmailExist" :emailErrorMsg="emailErrorMsg" />
                </tab-content>
                <tab-content title="Artist Application" :before-change="()=>validateStep('step2')">
                  <FormArtistApplication ref="step2" @on-validate="mergePartialModels" />
                </tab-content>
                <template slot="footer" slot-scope="props">
                  <div class="wizard-footer-left">
                    <wizard-button v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle" @click.native="props.prevTab()">Previous</wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Next</wizard-button>
                    <wizard-button v-if="props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle" :disabled="isLoading" :class="isLoading ? 'cursor-not-allowed' : ''">Create Account</wizard-button>
                  </div>
                </template>
              </form-wizard>
              <div class="text-grey-600 mt-6">
                Already have an account?
                <router-link :to="{path: '/login'}" class="no-underline border-b border-blue text-blue-600 font-bold" >
                  Log in
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import {
  FormSignupUser,
  FormArtistApplication,
} from '@/components';
import axios from 'axios';
import clevertap from 'clevertap-web-sdk';

export default {
  name: 'SignUp',
  data: () => ({
    finalModel: {},
    isEmailExist: false,
    emailErrorMsg: '',
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    isLoading() {
      return this.getLoading;
    },
  },
  methods: {
    ...mapActions('AuthModule', ['createAuthentication']),
    validateStep(name) {
      const refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    async onCompleteSave() {
      const formData = new FormData();

      const fullName = `${this.finalModel.first_name} ${this.finalModel.last_name}`.trim();

      formData.append('name', fullName);
      formData.append('email', this.finalModel.email);
      formData.append('password', this.finalModel.password);
      formData.append('dob', this.finalModel.dob);
      formData.append('bio', this.finalModel.bio);
      formData.append('language', this.finalModel.language);

      formData.append('first_name', this.finalModel.first_name);
      formData.append('last_name', this.finalModel.last_name);
      formData.append('phone_number', this.finalModel.phone_number);
      formData.append('missions', this.finalModel.missions);
      formData.append('church', this.finalModel.church);
      formData.append('links', this.finalModel.links);
      formData.append('self_introduction', this.finalModel.self_introduction);
      formData.append('monetize_choice', this.finalModel.monetize_choice);
      formData.append('legal_accepted', this.finalModel.legal_accepted ? '1' : '0');

      if (this.finalModel.profilePicture) {
        const avatarBase64 = await this.processFileBlob(this.finalModel.profilePicture);
        formData.append('avatar', avatarBase64);
      }

      const result = await this.createAuthentication(formData);
      if (result.status) {
        this.isEmailExist = false;
        this.$router.push({ name: 'SignupSuccess', params: { email: this.finalModel.email } });
      } else if (this.getStatus !== 200) {
        this.isEmailExist = true;
        this.emailErrorMsg = result.msg;
        clevertap.event.push('Signed Up', {
          'Method Used': 'Email',
          Email: this.finalModel.email,
          Status: 'Failed',
          Detail: this.getMessage,
        });
        this.$swal('Error', result.msg || 'Failed to create account.', 'error');
        this.$refs.formWizard.navigateToTab(0);
      }
    },
    async processFileBlob(url) {
      const response = await axios({ method: 'get', url, responseType: 'blob' });
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },
  },
  components: {
    FormSignupUser,
    FormArtistApplication,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Signup.vue